<template>
<div>

<h1 style="text-align: center;" class="mt-7">Account Settings</h1>
<br>
<div class="nav-tabs sc-bvTASY jPMoWD" style="overflow: scroll;display: flex;">
<router-link to="/dashboard/account" exact-active-class="activetabs" class="nav-item nav-link" style="background: none;border-radius: .5rem .5rem 0 0!important;border-left: .0625rem solid transparent; border-right: .0625rem solid transparent; border-top: .0625rem solid transparent;border-bottom: 0;">Account Information</router-link>
<router-link to="/dashboard/billing" exact-active-class="activetabs" class="nav-item nav-link" style="background: none;border-radius: .5rem .5rem 0 0!important;border-left: .0625rem solid transparent; border-right: .0625rem solid transparent; border-top: .0625rem solid transparent;border-bottom: 0;">Billing (invoices)</router-link>
</div>

</div>

</template>

<style>
.activetabs{
  background: #ffffff!important;
  border-color: #dde1ed!important;
  color: #ed1d62!important;
}
.nav-tabs .nav-link:hover {
    border: none;
}
.editandowebsite {
    background-color: #f9fafb;
    border-color: #1e90ff5e;
    outline: 0;
    box-shadow: inset 0 1px 2px rgb(46 54 80 / 8%), 0 0 0 0.2rem rgb(38 43 64 / 20%);
}
</style>

  <script>
  import ClickOutside from 'vue-click-outside';

  export default {
    props:['propsdata'],
    data() {
      return {
      };
    },
    methods: {
    },
    mounted() {
    },
    // do not forget this section
directives: {
  ClickOutside
}
  };
  </script>



// WEBPACK FOOTER //
// src/account-tabs.vue